export default {"src":"/_next/static/media/dislike-icon.8f7cab03.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};